import {getLocale} from '.';

export function pickMonth(date: Date) {
  const month = date.toLocaleString(getLocale(), {month: 'long'});

  return month[0].toUpperCase() + month.slice(1).replace(/\.$/, '');
}
